import React from 'react';

/* ── Paradise Ops logo ────────────────────────────────────────────── */
export function ParadiseOpsLogo({ size = 40, horizontal = false }) {
  if (horizontal) {
    return (
      <img
        src="/paradise-ops-logo-full.png"
        alt="Paradise Ops"
        style={{ height: size, width: 'auto', display: 'block' }}
      />
    );
  }
  return (
    <img
      src="/paradise-ops-logo-full.png"
      alt="Paradise Ops"
      style={{ height: size, width: 'auto', display: 'block' }}
    />
  );
}

/* ── Legacy logo mark (unused, kept for reference) ────────────────── */
export function LogoMark({ size = 32, className = '' }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 100 100"
      fill="none" xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="circleGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0099aa" />
          <stop offset="50%" stopColor="#00c4b4" />
          <stop offset="100%" stopColor="#f47c35" />
        </linearGradient>
        <linearGradient id="waveGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00b4c8" />
          <stop offset="100%" stopColor="#006e7f" />
        </linearGradient>
        <linearGradient id="arrowGrad" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#00c4b4" />
          <stop offset="100%" stopColor="#f47c35" />
        </linearGradient>
        <linearGradient id="palmGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3aaa5e" />
          <stop offset="100%" stopColor="#1a7a4a" />
        </linearGradient>
        <clipPath id="circleClip">
          <circle cx="50" cy="50" r="46" />
        </clipPath>
      </defs>

      {/* Outer ring gradient */}
      <circle cx="50" cy="50" r="49" fill="url(#circleGrad)" />
      {/* White inner circle */}
      <circle cx="50" cy="50" r="43" fill="white" />

      {/* Wave */}
      <path
        d="M14 62 Q24 50 34 58 Q44 66 54 54 Q64 42 76 52 L76 75 Q64 70 54 75 Q44 80 34 72 Q24 64 14 72 Z"
        fill="url(#waveGrad)" opacity="0.9"
        clipPath="url(#circleClip)"
      />
      <path
        d="M14 70 Q24 60 34 66 Q44 72 54 62 Q64 52 76 60 L76 80 Q64 76 54 80 Q44 84 34 78 Q24 72 14 78 Z"
        fill="#006e7f" opacity="0.5"
        clipPath="url(#circleClip)"
      />

      {/* Palm trunk */}
      <path
        d="M46 72 Q47 58 44 44 Q43 38 45 34"
        stroke="#5d3a1a" strokeWidth="3.5" strokeLinecap="round" fill="none"
        clipPath="url(#circleClip)"
      />
      {/* Palm fronds */}
      <path d="M45 34 Q36 26 28 30 Q33 36 45 36" fill="url(#palmGrad)" clipPath="url(#circleClip)" />
      <path d="M45 34 Q40 22 48 18 Q48 27 45 36" fill="url(#palmGrad)" clipPath="url(#circleClip)" />
      <path d="M45 34 Q52 24 60 26 Q55 33 45 36" fill="url(#palmGrad)" clipPath="url(#circleClip)" />
      <path d="M45 36 Q38 30 30 34 Q36 40 46 38" fill="#2d8a4e" opacity="0.7" clipPath="url(#circleClip)" />

      {/* Arrow — upward right */}
      <g clipPath="url(#circleClip)">
        <path
          d="M54 64 L72 34"
          stroke="url(#arrowGrad)" strokeWidth="5" strokeLinecap="round"
        />
        {/* Arrowhead */}
        <path
          d="M72 34 L62 32 M72 34 L70 44"
          stroke="url(#arrowGrad)" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

/* Full logo — for landing page hero / large displays */
export function LogoFull({ height = 60, className = '' }) {
  return (
    <svg
      height={height} viewBox="0 0 320 80"
      fill="none" xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="fullCircleGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0099aa" />
          <stop offset="60%" stopColor="#00c4b4" />
          <stop offset="100%" stopColor="#f47c35" />
        </linearGradient>
        <linearGradient id="fullWaveGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00b4c8" />
          <stop offset="100%" stopColor="#006e7f" />
        </linearGradient>
        <linearGradient id="fullArrowGrad" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#00c4b4" />
          <stop offset="100%" stopColor="#f47c35" />
        </linearGradient>
        <clipPath id="fullCircleClip">
          <circle cx="40" cy="40" r="37" />
        </clipPath>
      </defs>
      {/* Icon */}
      <circle cx="40" cy="40" r="39" fill="url(#fullCircleGrad)" />
      <circle cx="40" cy="40" r="34" fill="white" />
      <path d="M6 50 Q14 41 22 46 Q30 52 38 43 Q46 34 56 41 L56 58 Q46 54 38 58 Q30 63 22 57 Q14 51 6 57 Z" fill="url(#fullWaveGrad)" opacity="0.9" clipPath="url(#fullCircleClip)" />
      <path d="M6 56 Q14 48 22 52 Q30 57 38 50 Q46 43 56 48 L56 64 Q46 61 38 64 Q30 68 22 63 Q14 58 6 63 Z" fill="#006e7f" opacity="0.45" clipPath="url(#fullCircleClip)" />
      <path d="M37 58 Q37.5 47 35.5 36 Q35 31 36.5 27" stroke="#5d3a1a" strokeWidth="2.8" strokeLinecap="round" fill="none" clipPath="url(#fullCircleClip)" />
      <path d="M36.5 27 Q30 21 24 24 Q27.5 29 36.5 28" fill="#3aaa5e" clipPath="url(#fullCircleClip)" />
      <path d="M36.5 27 Q33 18 38.5 15 Q39 22 36.5 28" fill="#3aaa5e" clipPath="url(#fullCircleClip)" />
      <path d="M36.5 27 Q42 19 47 21 Q43.5 27 36.5 28" fill="#3aaa5e" clipPath="url(#fullCircleClip)" />
      <g clipPath="url(#fullCircleClip)">
        <path d="M43 51 L56 27" stroke="url(#fullArrowGrad)" strokeWidth="4" strokeLinecap="round" />
        <path d="M56 27 L49 26 M56 27 L55 34" stroke="url(#fullArrowGrad)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      {/* Text */}
      <text x="92" y="37" fontFamily="system-ui,-apple-system,sans-serif" fontWeight="800" fontSize="22" letterSpacing="-0.5" fill="#0d5e6e">PARADISE</text>
      <line x1="92" y1="44" x2="218" y2="44" stroke="#e2e8f0" strokeWidth="1" />
      <text x="92" y="58" fontFamily="system-ui,-apple-system,sans-serif" fontWeight="800" fontSize="22" letterSpacing="-0.5" fill="#f47c35">OPS</text>
      <text x="92" y="72" fontFamily="system-ui,-apple-system,sans-serif" fontWeight="500" fontSize="9" letterSpacing="1.8" fill="#64748b">DYNAMIC SOLUTIONS • OPTIMIZED GROWTH</text>
    </svg>
  );
}

const defaultProps = { width: 18, height: 18, stroke: 'currentColor', fill: 'none', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' };

const icon = (paths) => (props) => {
  const p = { ...defaultProps, ...props };
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={p.width} height={p.height} fill={p.fill} stroke={p.stroke} strokeWidth={p.strokeWidth} strokeLinecap={p.strokeLinecap} strokeLinejoin={p.strokeLinejoin}>{paths}</svg>;
};

export const IconDashboard   = icon(<><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></>);
export const IconScan        = icon(<><path d="M3 7V5a2 2 0 0 1 2-2h2"/><path d="M17 3h2a2 2 0 0 1 2 2v2"/><path d="M21 17v2a2 2 0 0 1-2 2h-2"/><path d="M7 21H5a2 2 0 0 1-2-2v-2"/><line x1="7" y1="12" x2="17" y2="12"/></>);
export const IconInventory   = icon(<><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></>);
export const IconOrders      = icon(<><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></>);
export const IconVoice       = icon(<><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></>);
export const IconFarmers     = icon(<><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>);
export const IconBar         = icon(<><path d="M8 22H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1h-4"/><path d="M8 10h8"/><path d="M12 10v8"/><path d="M9 22v-4"/><path d="M15 22v-4"/></>);
export const IconSupplies    = icon(<><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/><line x1="12" y1="12" x2="12" y2="17"/><line x1="9.5" y1="14.5" x2="14.5" y2="14.5"/></>);
export const IconUsers       = icon(<><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>);
export const IconVendors     = icon(<><circle cx="12" cy="8" r="4"/><path d="M6 20v-2a6 6 0 0 1 12 0v2"/><path d="M19 16l2 2-4 4"/></>);
export const IconSignOut     = icon(<><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></>);
export const IconIssy        = icon(<><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/><circle cx="12" cy="12" r="3" fill="currentColor" stroke="none"/></>);
export const IconChevronDown = icon(<polyline points="6 9 12 15 18 9"/>);
export const IconCheck       = icon(<polyline points="20 6 9 17 4 12"/>);
export const IconAlert       = icon(<><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></>);
export const IconRefresh     = icon(<><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></>);
export const IconPlus        = icon(<><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>);
export const IconX           = icon(<><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>);
export const IconEdit        = icon(<><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></>);
export const IconSettings    = icon(<><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></>);
export const IconMenu        = icon(<><path d="M3 5h18M3 12h18M3 19h18"/><circle cx="19" cy="5" r="2" fill="currentColor" stroke="none"/><circle cx="19" cy="12" r="2" fill="currentColor" stroke="none"/><circle cx="19" cy="19" r="2" fill="currentColor" stroke="none"/></>);
